import Card from '../../components/Card'
import Modal from './Modal'

export default Object.assign(Modal, Card)



// WEBPACK FOOTER //
// ./src/components/Modal/index.js